import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../contexts/AuthContext";

const languages = [
  { label: "Slovenščina", value: "Slovenščina" },
  {
    label: "Srbski/hrvaški/bosanski jezik",
    value: "Srbski/hrvaški/bosanski jezik",
  },
  { label: "Angleščina", value: "Angleščina" },
];

const LanguageDropdown = () => {
  const { setLanguage, language } = useAuth();

  useEffect(() => {
    setLanguage(languages[0]);
  }, []);

  const handleChange = (e) => {
    const selected = languages.find((lang) => lang.value === e.target.value);
    setLanguage(selected);
  };

  return (
    <div className="relative inline-block text-left w-full">
      <div className="flex items-center px-4 py-2 max-w-80 w-full text-gray-900 font-semibold italic border border-gray-300 rounded-md shadow-sm bg-white hover:bg-gray-100">
        <select
          value={language?.value}
          onChange={handleChange}
          className="appearance-none bg-transparent w-full focus:outline-none italic font-semibold text-gray-900"
        >
          {languages.map((lang) => (
            <option key={lang.value} value={lang.value}>
              {lang.label}
            </option>
          ))}
        </select>
        <FontAwesomeIcon icon={faChevronDown} className="ml-auto w-4 h-4" />
      </div>
    </div>
  );
};

export default LanguageDropdown;
